export default class PeriodicidadeUtils {
	static possuiPeriodicidade(item) {
		return !!item && !!item.periodicidade && Number(item.periodicidade) > 0
	}

	static mesesPeriodicidade(item) {
		return PeriodicidadeUtils.possuiPeriodicidade(item) ? Math.trunc(Number(item.periodicidade)) : null
	}

	static valorMedioMensal(valorTotal, periodicidade) {
		if (!periodicidade || !valorTotal) {
			return null
		}
		return Number(valorTotal) / Number(periodicidade)
	}

	static formatarMoeda(valor) {
		if (!valor || isNaN(Number(valor))) {
			return ''
		}
		return Number(valor).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
	}
}
